package one.healthium.data.user.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class UserDto(
    @SerialName("profile") val profile: UserProfileDto? = null,
    @SerialName("purchases") val purchases: UserPurchasesDto? = null,
    @SerialName("system") val system: UserSystemDto? = null,
    @SerialName("pushTokens") val pushTokens: List<PushTokenDto>? = null,
)